import React from "react";
import "react-awesome-slider/dist/styles.css";
import Home from "./home";

const HomeContainer = ({ }) => {

  return <Home />;
};

export default HomeContainer;
